import { MapPin } from "lucide-react";
import Link from "next/link";

import { WhatsAppLinks } from "./whatsapp-links";

interface HeaderContactProps {
  scrolled: boolean;
}

const HeaderContact = ({ scrolled }: HeaderContactProps) => {
  return (
    <address
      className={`bg-gradient-primary mx-4 hidden rounded-b-xl py-3 text-white transition-all duration-500 ease-in-out md:flex ${scrolled ? "pointer-events-none -translate-y-5 opacity-0" : "translate-y-0 opacity-100"} `}
    >
      <div className="container mx-auto flex max-w-7xl flex-row items-center px-6 sm:justify-end lg:px-8">
        <div className="flex gap-20">
          <span className="text-sm tracking-wide">
            <Link
              href={process.env.NEXT_PUBLIC_GOOGLE_MAPS_URL || ""}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2"
            >
              <MapPin className="h-6 w-6" strokeWidth={1.5} /> R. Benjamin
              Constant, 348 - Centro - Lages, SC
            </Link>
          </span>
          <WhatsAppLinks />
        </div>
      </div>
    </address>
  );
};

export default HeaderContact;
